import type { SVGProps } from "react";
export function Website(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <g clipRule="evenodd" fill="currentColor" fillRule="evenodd">
        <path d="m.833374 8.00004c0-3.95804 3.208626-7.166664 7.166666-7.166664 3.95806 0 7.16666 3.208624 7.16666 7.166664 0 3.95806-3.2086 7.16666-7.16666 7.16666-3.95804 0-7.166666-3.2086-7.166666-7.16666zm7.166666-6.16666c-3.40576 0-6.16667 2.76091-6.16667 6.16666 0 3.40576 2.76091 6.16666 6.16667 6.16666s6.16666-2.7609 6.16666-6.16666c0-3.40575-2.7609-6.16666-6.16666-6.16666z" />
        <path d="m8.36512.991747c.18868.201633.17817.518043-.02346.706713-1.73447 1.62302-2.68849 3.91268-2.61962 6.28709.00028.00966.00028.01933 0 .02899-.06887 2.37436.88515 4.66406 2.61962 6.28706.20163.1887.21214.5051.02346.7067-.18868.2017-.50508.2122-.70672.0235-1.94037-1.8157-3.00924-4.3758-2.93635-7.03176-.07289-2.65593.99598-5.21606 2.93635-7.031753.20164-.188676.51804-.178173.70672.02346z" />
        <path d="m7.63495.991747c.18868-.201633.50509-.212136.70672-.02346 1.94033 1.815693 3.00923 4.375823 2.93633 7.031753.0729 2.65596-.996 5.21606-2.93633 7.03176-.20163.1887-.51804.1782-.70672-.0235-.18867-.2016-.17817-.518.02346-.7067 1.73447-1.623 2.68849-3.9127 2.61959-6.28706-.0003-.00966-.0003-.01933 0-.02899.0689-2.37441-.88512-4.66407-2.61959-6.28709-.20163-.18867-.21213-.50508-.02346-.706713z" />
        <path d="m1.21338 5.77784c0-.27615.22386-.5.5-.5h12.57112c.2761 0 .5.22385.5.5 0 .27614-.2239.5-.5.5h-12.57112c-.27614 0-.5-.22386-.5-.5z" />
        <path d="m1.21338 10.2223c0-.27619.22386-.50004.5-.50004h12.57332c.2762 0 .5.22385.5.50004 0 .2761-.2238.5-.5.5h-12.57332c-.27614 0-.5-.2239-.5-.5z" />
      </g>
    </svg>
  );
}
